/* const public_url_images = 'http://127.0.0.1:8000/storage' */
const public_url_images = 'https://diazapps.com/public_diazappsnfts/storage'

export default public_url_images